interface ProgressBarProps {
  progress: number
  visible: boolean
}

export function ProgressBar({ progress, visible }: ProgressBarProps) {
  if (!visible) return null

  return (
    <div
      role="progressbar"
      aria-valuenow={progress}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label="Download progress"
      className="w-full h-1.5 bg-white/20 rounded-full overflow-hidden mt-3"
    >
      <div
        className="h-full bg-twitter-blue rounded-full transition-[width] duration-300 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  )
}
